/**************************************************
 * Nombre:       IngresoTexto
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Button, Grid2, Typography} from "@mui/material";
import {CloudUploadOutlined,} from "@mui/icons-material";
import {useEffect, useState} from "react";
import {theme} from "../../Tema";


const IngresoPdf = ({
                        props,
                        dato,

                    }) => {
    const {getValues, setValue, watch} = props
    const [imagen, setImagen] = useState('')

    const ingresoImagen = (data) => {
        if (data.target.files && data.target.files[0]) {
            setValue(dato, data.target.files[0])
            // console.log(data.target.files[0])
        }
    }


    useEffect(() => {
        let obj = getValues()

        if (typeof obj[dato] === 'object') {
            setImagen(obj[dato])
        } else {
            setImagen(obj[dato])
        }


    }, [watch(dato)]);
    return (
        <Grid2
            container
            justifyContent={'flex-start'}
            alignItems={'center'}
            size={{xs: 12, sm: 12, md: 12}}>


            <Grid2 container size={{xs: 8, sm: 8, md: 8}}>
                <Typography
                    onClick={() => window.open(typeof imagen === 'string' ? imagen : URL.createObjectURL(imagen))}
                    sx={{
                        lineHeight: 1.1,
                        cursor: 'pointer',
                        borderBottom: 0,
                        "&:hover": {
                            borderBottom: 1
                        }


                    }}
                >{acortarUrl(typeof imagen === 'string' ? imagen : imagen?.name)}</Typography>
            </Grid2>


            <Grid2 container size={{xs: 4, sm: 4, md: 4}} justifyContent={'flex-end'}>

                <Button
                    component="label"
                    role={undefined}
                    variant="outlined"
                    tabIndex={-1}
                    startIcon={<CloudUploadOutlined/>}
                    sx={{p: 1, color: theme.palette.primary.main}}
                    fullWidth
                >
                    Subir Pdf
                    <input
                        type="file"
                        hidden
                        onChange={ingresoImagen}
                        accept="application/pdf"

                    />
                </Button>


            </Grid2>


        </Grid2>

    )

}
export default IngresoPdf


const acortarUrl = (texto) => {

    if (!texto) {
        return ''
    }

    if (texto.length < 25) {
        return texto
    } else {
        texto = '...' + texto.substring(texto.length - 25, texto.length)
        return texto
    }

}
